import './Icon.css'
import ArrowIcon from './icons/arrowIcon'

export const ArrowBackButton = () => (
  <a
    className="icon-border icon-container"
    href={`${import.meta.env.VITE_DIGITANE_ONLINE_URL}/s/`}
  >
    <div className="icon-button">
      <ArrowIcon className="icon" height="21" />
      <div className="icon-caption">タウンへ</div>
    </div>
  </a>
)
